import { render, staticRenderFns } from "./LosedFeatureBlock.vue?vue&type=template&id=2ef75f83&scoped=true&"
import script from "./LosedFeatureBlock.vue?vue&type=script&lang=js&"
export * from "./LosedFeatureBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef75f83",
  null
  
)

export default component.exports